import { Flex } from '@tpr/core';
import React from 'react';
import Styles from './hint.module.scss';
export var Hint = function (props) { return (React.createElement(Flex, { cfg: { pl: 3 }, className: props.expanded ? Styles.root : Styles.collapsed }, props.children)); };
//# sourceMappingURL=hint.js.map